/** Taille native des sprites véhicules décor (px, fond transparent). */
export const DECOR_VEHICLE_SPRITE_PX = 128;

export interface CircuitVehicleSpriteDef {
  id: string;
  label: string;
  /** Chemin public (ex. /assets/circuit-decor/vehicles/van.png). */
  imagePath: string;
}

/**
 * Catalogue des véhicules décoratifs.
 * Ajoutez une entrée ici + un PNG transparent dans client/public/assets/circuit-decor/vehicles/.
 */
export const CIRCUIT_VEHICLE_SPRITES: CircuitVehicleSpriteDef[] = [
  {
    id: 'sweeper',
    label: 'Camion nettoyage',
    imagePath: '/assets/circuit-decor/vehicles/sweeper.png',
  },
  {
    id: 'depanneuse',
    label: 'Dépanneuse',
    imagePath: '/assets/circuit-decor/vehicles/depanneuse.png',
  },
  {
    id: 'safety-car',
    label: 'Directeur de course',
    imagePath: '/assets/circuit-decor/vehicles/safety-car.png',
  },
  {
    id: 'tracteur',
    label: 'Tracteur récupération',
    imagePath: '/assets/circuit-decor/vehicles/tracteur.png',
  },
  { id: 'epave', label: 'Épave', imagePath: '/assets/circuit-decor/vehicles/epave.png' },
  { id: 'pneus', label: 'Piles de pneus', imagePath: '/assets/circuit-decor/vehicles/pneus.png' },
];

const SPRITE_BY_ID = new Map(CIRCUIT_VEHICLE_SPRITES.map((sprite) => [sprite.id, sprite]));

export function getCircuitVehicleSprite(spriteId: string): CircuitVehicleSpriteDef | undefined {
  return SPRITE_BY_ID.get(spriteId);
}

export function isValidCircuitVehicleSpriteId(spriteId: string): boolean {
  return SPRITE_BY_ID.has(spriteId);
}

export function getCircuitVehicleSpritePath(spriteId: string): string | undefined {
  return SPRITE_BY_ID.get(spriteId)?.imagePath;
}
